import { JsonObject } from 'ta-json';
import { GetAllRetailers_allRetailers_edges_node_retailerOptions_hornbachOptions } from '@src/app/generated/GetAllRetailers';
import { HornbachOptionsInput } from '@src/app/generated/globalTypes';
import { HornbachOptions } from '@ess/jg-rule-executor/dist/src/domain/hornbach-options';

/**
 * EanOptions
 */
@JsonObject()
export class PortalHornbachOptions extends HornbachOptions {
  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_hornbachOptions): PortalHornbachOptions {
    return new PortalHornbachOptions(
      gql.integrationServiceUrl,
      gql.articleId,
      gql.companyCode,
      gql.locale
    );
  }

  toGqlInput(): HornbachOptionsInput {
    return {
      integrationServiceUrl: this.integrationServiceUrl,
      articleId: this.articleId,
      companyCode: this.companyCode,
      locale: this.locale,
    };
  }
}
